var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-b-6",attrs:{"id":'jump-' + _vm.index}},[_c('video-player',{attrs:{"url":_vm.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }